import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
export default class Other extends Component {
    
    _isMounted = false;
    constructor(props) {
        super(props);
   
        this.state = {
            isPremiumCustomer: false, message: "", 
            //othercontainer: (<div className="fa-3x">
            //    <h6 className='text-center' ><i className="fas fa-spinner fa-pulse"></i>  Please wait while billing info loads</h6>
            //</div>),
            othercontainer: "",
            pmID: ""
           
        }
    }
    checkBilling = async () => {     

        const billResp = await fetch('api/billing/hasteambilling', {
            method: 'GET',
            credentials: 'same-origin'
        });
       
        if (billResp.status === 200) {
            try {
                const jdata = await billResp.json();
                //console.log(jdata);
                if (this._isMounted) {
            
                    let msg = jdata.message;
                    //console.log(jdata.hasTeamBilling);
                    await this.setState({ message: msg, isPremiumCustomer: jdata.hasTeamBilling },
                        () => { this.setLandingPage() });
                }

            } catch (e) {


                this.setState({ message: '500: Check console' })
            }
        }
        else if (billResp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else {

            this.setState({ message: 'There was a problem, please try again later' })
        }
       
    }

    setLandingPage = () => {
        //console.log(this.state.isPremiumCustomer);
        this.setState({
            othercontainer: (
                <div>
                    {this.state.isPremiumCustomer ? (
                        <>
                            <p className="card-text">Gstitch Meeting connects your YouTube and Zoom accounts</p>
                            <button onClick={this.createLink} className="btn btn-secondary">Create Gstitch Meeting Link</button>
                        </>
                    ) : (
                            <>
                                <p className="card-text">Gstitch Meeting is available to Premium customers</p>
                                <Link to="/billing" className="btn btn-secondary">
                                    <i className="fa fa-credit-card"></i>
                                    <span className="menu-text">Billing</span>
                                </Link>
                            </>
                        )}
                </div>
            )
        });
    }

    async componentDidMount() {
        this._isMounted = true;       
       // this.props.showBusy(true);
        await ( async () => {
            this.checkBilling()
        })();
      
    }
   



    createLink = async () => {
        const linkResponse = await fetch('api/billing/createlink', {
            method: 'POST',
            credentials: 'same-origin'
        });
        if (linkResponse.status === 200) {
            try {
                const jdata = await linkResponse.json();

                if (this._isMounted) {

                    const link = jdata.ret;
                    //console.log(link);
                    this.setState({
                        othercontainer: (
                            <div>
                                {(
                                    <>
                                        <p className="card-text">Connect your YouTube and Zoom accounts.</p>
                                        <p className="card-text">This Link is valid for one hour.</p>
                                        <a href={link}  className="btn btn-secondary">Gstitch Meeting</a>
                                    </>
                                )}
                            </div>
                        )
                    });
                }

            } catch (e) {


                this.setState({ message: '500: Check console' })
            }
        }
        else if (linkResponse.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else {

            this.setState({ message: 'There was a problem, please try again later' })
        }
    }
 

    
    render() {
    
        const othercontainer = this.state.othercontainer;
       
        //const othercontainer = null;

        const msg = this.state.message ;
        return (
            <div className="container-fluid">  
                             
                <div className="row">
                    <div className="col-sm-6">
                        <div className="card">
                            <h5 className="card-header">Other Services</h5>
                            <div className="card-body">
                                {othercontainer}
                            </div>
                        </div>
                    </div>
                    
                </div> 
                <p>{msg}</p>
            </div>
         
        );
    }
}
